import { AccessorsMutatorsDecorator, Model } from '../../helpers';

/**
 * @class CalendarTileSettings
 * @property {number} id
 * @property {string} name
 * @property {Country} country
 * @property {string} status
 * @property {number} roomId
 * @property {string} from
 * @property {string} to
 * @property {string} type
 * @property {string} text
 * @property {object} details
 * @property {object} css
 * @property {boolean} showDetails
 */
export class CalendarTileSettings extends Model {

    static get TYPE_RESERVATION() {

        return 'reservation';
    }

    static get TYPE_ADDITIONAL_EVENT() {

        return 'additional-event';
    }

    /**
     *
     * CAUTION: Don't add new properties here. It is used for deprecated reasons.
     * Best solution is to setup through constructor or by manually properties initialization
     *
     * @param roomId
     * @param from
     * @param to
     * @param type
     * @param text
     * @param details
     * @param css
     * @param showDetails
     * @return {CalendarTileSettings}
     */
    static buildFromArray(roomId, from, to, type, text, details, css, showDetails = false) {

        return new CalendarTileSettings({roomId, from, to, type, text, details, css, showDetails});
    }
}

AccessorsMutatorsDecorator(
    'roomId',
    'from',
    'to',
    'type',
    'text',
    'details',
    'css',
    'showDetails',
)(CalendarTileSettings);



// WEBPACK FOOTER //
// ./src/pms-api/models/calendar-tile-settings.model.js